export default "__VITE_ASSET__c0f76017__"